import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-default/index.css'
import vuefire from 'vuefire'

Vue.config.productionTip = false

Vue.use(ElementUI)
Vue.use(vuefire)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  template: '<App />',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js